export default {
  customized: 'Angepasst',
  noMatches: 'Keine Komponenten gefunden',
};
